import { Component, OnInit } from '@angular/core';
import { SupplierBillService, SupplierBillFilter, SupplierBillId } from '../../services/supplier-bill.service';
import { OutcomeService, OutcomeData, OutcomedBill } from '../../services/outcome.service';
import { PermissionService, SpecialPermissions } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { Utils } from '../../util';
import { toast } from 'angular2-materialize';

interface Data{
  supplierName: string;
  date: string;
  folio: string;
  payMethod: string;
  moneyBill: string;
  moneyBillResidue: string;
  moneyNote: string;
  moneyOutcome: string;

  datas?: Data[];
}

@Component({
  selector: 'app-transaction-report-supplier',
  templateUrl: './transaction-report-supplier.component.html',
  styleUrls: ['./transaction-report-supplier.component.css']
})
export class TransactionReportSupplierComponent implements OnInit {
  allowed: boolean = false;
  permission: Partial<{[K in keyof typeof SpecialPermissions]: boolean}> = {};

  supplierBills: Data[] = [];
  chargeNotes: Data[] = [];
  outcomes: Data[] = [];
  filteredData: Data[] = [];

  constructor(
    private service: SupplierBillService,
    private outcomeService: OutcomeService,
    private outcomeData: OutcomeData,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, 'SPECIAL');
        if(!this.permission || !this.permission.suppliersTransactionReport){
          toast('No tiene permisos.', 3000);
          this.router.navigate(['/']);
        }
        else this.allowed = true;
    });

    let billSub = this.service.getSupplierBills().subscribe(tempSupplierBills => {
      billSub.unsubscribe();
      let outcomeSub = this.outcomeService.getOutcomes().subscribe(outcomes => {
        outcomeSub.unsubscribe();

        this.supplierBills = tempSupplierBills.map( ({id, ...supplierBill}) => {
          let outcomed = new OutcomedBill(supplierBill as any);
          supplierBill.supplierName = supplierBill.supplierObj.name;
          supplierBill.residue = outcomed.residue;
          supplierBill.payMethod = '';
          supplierBill.moneyBillResidue = this.money(supplierBill.residue);
          supplierBill.moneyBill = this.money(supplierBill.total);

          supplierBill.datas = [
            ...supplierBill.chargeNotes.map(cn => ({
              supplierName: supplierBill.supplierName,
              date: cn.date,
              folio: cn.folio || '',
              payMethod: '',
              moneyBill: '',
              moneyBillResidue: '',
              moneyNote: `${this.money(cn.total)}`,
              moneyOutcome: ''
            }) ),
            ...outcomes.filter( ({bills}) => bills.some( ({supplierBillId: cbId}) => cbId == id ) ).map( outcome => ({
              supplierName: outcome.supplierObj.name,
              date: outcome.date,
              folio: '',
              payMethod: this.outcomeData.statusObjects[outcome.payMethod].name,
              moneyBill: '',
              moneyBillResidue: '',
              moneyNote: '',
              moneyOutcome: `${this.money(outcome.bills.find( ({supplierBillId: cbId}) => cbId == id ).amount)}`
            }) )
          ].sort( ({date}, {date: date2}) => date < date2 ? 1 : -1 );

          return supplierBill;
        });
        console.log(this.supplierBills);

        this.filterBar = new SupplierBillFilter([...this.supplierBills], {dateIndex: 3});
        this.applyFilterBar();
      });
    });
  }

  ngOnInit() {
  }


  money = Utils.money;

  ////////////////////////////////////////////////////////////////////FilterBar
  filterBar: SupplierBillFilter = new SupplierBillFilter([], {});
  applyFilterBar(){
    this.filteredData = this.filterBar.filteredData.sort( ({date}, {date: date2}) => date < date2 ? 1 : -1 );
  }
  ////////////////////////////////////////////////////////////////////FilterBar

}
